/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/17/2023
 */
import StorageService from "./StorageService"
import api from "../services/AuthApi"
let base64 = require("base-64")

const baseURL = process.env.REACT_APP_BASE_URL

const Logout = async () => {
  const username = StorageService.getUsername()

  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Basic " +
        base64.encode(
          process.env.REACT_APP_AUTH_USERNAME +
            ":" +
            process.env.REACT_APP_AUTH_PASSWORD
        ),
    },
  }

  const data = {
    revokeAction: "RATU",
    username: username,
  }

  try {
    const res = await api.delete("/tokens/revoke", { data: data }, config)
    if (res.status === 200) {
      sessionStorage.clear()
      localStorage.clear()
      window.location.href = baseURL + "/login"
    }
  } catch (error) {
    sessionStorage.clear()
    localStorage.clear()
    window.location.href = baseURL + "/login"
    console.log("Logout Error", error)
  }
}

const LogoutWithoutAPI = () => {
  sessionStorage.clear()
  localStorage.clear()
  window.location.href = baseURL + "/login"
}

const AuthService = {
  Logout,
  LogoutWithoutAPI,
}

export default AuthService
